interface StarRatingDisplayProps {
  rating?: number;
}

export const StarRatingDisplay: React.FC<StarRatingDisplayProps> = ({ rating }) => {
  if (typeof rating !== 'number' || Number.isNaN(rating) || rating < 1 || rating > 5) {
    return <span className="text-sm text-slate-400">—</span>;
  }
  const rounded = Math.round(rating);
  return (
    <span className="inline-flex items-center gap-1" aria-label={`5段階中${rounded}の評価`}>
      <span className="tracking-tight text-amber-500">
        {'★'.repeat(rounded)}
        <span className="text-slate-300">{'★'.repeat(5 - rounded)}</span>
      </span>
      <span className="text-xs font-medium text-slate-600">{rating.toFixed(1)}</span>
    </span>
  );
};
